// import React, {useState,useEffect,Suspense, lazy} from "react";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import OneBtnAlert from "../components/comComponents/OneBtnAlert";
// const ErrorModule = ({e}) => {
//     const [alertOpen, setAlertOpen] = useState(false); //알림 오픈 여부
//     const [alertContents, setAlertContents] = useState(''); //알림 내용
//     const [alertIcon, setAlertIcon] = useState(''); //알림 아이콘
//     const navigate = useHistory();
//     const alertFun = (open) => {
//         setAlertOpen(open);
//     }
//     useEffect(()=> {
//         console.log(e.status);
//         if(e.status===500 ) {
//             console.log(e.responseJSON.msgCd);

//         }else if(e.status===404){
//             navigate.push("/404");
//             chkError();
//         }else{
//             navigate.push("/500");
//         }

//     },[e]);

//     const chkError = () => {
//         console.log(e.re)
//         setAlertIcon("F");
//         setAlertContents(<>부정한 접근입니다.</>);
//         alertFun(true);
//     }

//     return(
//         <>
//             {alertOpen ? <OneBtnAlert alertContents={alertContents} alertOpen={alertOpen} alertFun={alertFun} alertIcon={alertIcon}/> : <></>}
//         </>
//     )
// }

// export default ErrorModule;


export function ErrorModule(e)  {
    console.log(e);
    if(e.status===500 ) {
        if(e.responseJSON.msgCd == undefined) {
            sessionStorage.clear();
            window.location.href="/500";
            return false;
        }else if(e.responseJSON.msgCd != "") {
            return true;
        }else{
            sessionStorage.clear();
            window.location.href="/500";
            return false;
        }
    }else if(e.status===404){
        window.location.href="/404";
        return false;
    }else if(e.status===401){
        sessionStorage.clear();
        window.location.href = "/";
    }
    else{
        sessionStorage.clear();
        window.location.href="/500";
        return false;
    }
}